import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Privacy() {
    return (
        <div className="page">
            <Header />
            <div className="container" style={{ padding: '48px 24px', maxWidth: 800 }}>
                <h1>Polityka prywatności</h1>
                <p className="text-muted mt-sm">Ostatnia aktualizacja: marzec 2026</p>

                <div className="glass mt-lg" style={{ padding: '32px' }}>
                    <h2 style={{ fontSize: '1.3rem', marginBottom: '16px' }}>1. Jakie dane zbieramy?</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        PickOneGift zbiera minimalne dane niezbędne do działania usługi:
                    </p>
                    <ul style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8, paddingLeft: '20px', marginTop: '8px' }}>
                        <li><strong>Email twórcy listy</strong> — służy wyłącznie do wysłania powiadomienia o wybranym prezencie.</li>
                        <li><strong>Dane wysyłkowe odbiorcy</strong> — imię, adres, telefon, email.</li>
                        <li><strong>Informacje o prezentach</strong> — tytuły, zdjęcia, linki do produktów.</li>
                    </ul>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>2. Jak chronione są dane wysyłkowe?</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        <strong>Dane wysyłkowe NIE są przechowywane w naszej bazie danych.</strong>{' '}
                        Są one wysyłane wyłącznie w wiadomości e-mail do twórcy listy i nie są
                        nigdzie zapisywane na naszych serwerach. Po wysłaniu e-maila dane te nie
                        istnieją w naszym systemie.
                    </p>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>3. Jak długo przechowujemy dane?</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        Listy prezentów są przechowywane w bazie danych do momentu ich usunięcia
                        przez twórcę (za pomocą tokenu usunięcia) lub do automatycznego wygaśnięcia.
                        Sesje widgetu wygasają automatycznie po 24 godzinach.
                    </p>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>4. Komu udostępniamy dane?</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        Nie udostępniamy żadnych danych osobowych stronom trzecim. Korzystamy z
                        usług AWS (Amazon Web Services) do hostingu i wysyłki e-maili, zgodnie z
                        ich polityką prywatności i przepisami RODO.
                    </p>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>5. Pliki cookies</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        PickOneGift nie wykorzystuje plików cookies do śledzenia użytkowników.
                        Nie stosujemy żadnych narzędzi analitycznych ani reklamowych.
                    </p>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>6. Kontakt</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        W przypadku pytań dotyczących prywatności, prosimy o kontakt pod adresem:{' '}
                        <a href="mailto:privacy@pickonegift.com">privacy@pickonegift.com</a>
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
}
